import React, { useState, useEffect, useMemo, useCallback } from "react";
import hand from "../../../assets/waving-hand-sign_1f44b 1.png";
import v1 from "../../../assets/v1.png";
import { Link } from "react-router-dom";
import TeacherDas1 from "../../../assets/TeacherDas1.png";
import TeacherDas2 from "../../../assets/TeacherDas2.png";
import TeacherDas3 from "../../../assets/TeacherDas3.png";
import profile from "../../../assets/new images/students.png";
import Banner from "../../../assets/Group 75.png";
import axios from "axios";
import apiKey from "../../../config/apiKey";
import { useTranslation } from "react-i18next";

const TeacherMainBody = () => {
  const { t } = useTranslation();
  const teacher = JSON.parse(localStorage.getItem("edo-teacher"));
  const token = teacher?.token || "";
  const userId = teacher?.teacher?.id || "";

  const [formUser, setFormUser] = useState({ name: "" });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [homeCount, setHomeCount] = useState(0);
  const [onlineCount, setOnlineCount] = useState(0);
  const [totalStudents, setTotalStudents] = useState(0);
  const [records, setRecords] = useState([]);

  // Fetch teacher profile
  const fetchUser = useCallback(async () => {
    if (!userId || !token) return;
    try {
      const res = await axios.get(`${apiKey}/api/edolutions/teacher/getuser/${userId}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setFormUser(res.data || {});
    } catch (err) {
      console.error("User fetch error:", err);
    }
  }, [userId, token]);

  // Fetch dashboard metrics + data
  const fetchMetricsAndRecent = useCallback(async () => {
    if (!userId || !token) return;
    setLoading(true);
    setError("");

    try {
      const [allRes, homeRes, onlineRes] = await Promise.all([
        axios.get(`${apiKey}/api/edolutions/teacher/read-notifications-all/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${apiKey}/api/edolutions/teacher/read-notifications-home/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
        axios.get(`${apiKey}/api/edolutions/teacher/read-notifications/${userId}`, {
          headers: { Authorization: `Bearer ${token}` },
        }),
      ]);
      console.log(allRes, homeRes, onlineRes);

      const allData = allRes?.data?.data || [];
      setRecords(allData);
      setTotalStudents(allData.length);
      setHomeCount(homeRes?.data?.data?.length || 0);
      setOnlineCount(onlineRes?.data?.data?.length || 0);
    } catch (err) {
      console.error("Dashboard fetch error:", err);
      setError(t("teacherDash.dashboard.loadError"));
    } finally {
      setLoading(false);
    }
  }, [userId, token]);

  useEffect(() => {
    fetchUser();
    fetchMetricsAndRecent();
  }, [fetchUser, fetchMetricsAndRecent]);

  const lastThree = useMemo(() => (records?.length ? records.slice(-3) : []), [records]);

  const Skeleton = ({ className = "" }) => (
    <div className={`animate-pulse rounded-xl bg-gray-100 ${className}`} />
  );

  return (
    <div className="w-full">
      {/* HERO SECTION */}
      <div className="relative overflow-hidden rounded-3xl bg-gradient-to-tr from-[#EE5F2B] to-[#2A3A54]">
        <div className="absolute -top-16 -right-16 h-64 w-64 rotate-12 rounded-3xl bg-white/10 blur-2xl" />
        <div className="absolute -bottom-12 -left-12 h-56 w-56 -rotate-12 rounded-3xl bg-black/10 blur-2xl" />

        <div className="relative z-10 grid grid-cols-1 lg:grid-cols-3 gap-6 p-6 md:p-8">
          <div className="lg:col-span-2 flex items-center gap-4">
            <img src={hand} alt="" className="h-7 w-7 drop-shadow-sm" />
            <div>
              <h1 className="text-white text-2xl md:text-3xl font-extrabold tracking-tight">
                {formUser?.name
                  ? t("teacherDash.dashboard.helloName", { name: formUser.name })
                  : t("teacherDash.dashboard.hello")}{" "}
                👋
              </h1>
              <p className="text-white/90 text-sm md:text-base">
                {t("teacherDash.dashboard.welcomeSubtitle")}
              </p>
            </div>
          </div>
          <div className="lg:col-span-1 flex items-center justify-center">
            {/* <img
              src={Banner}
              alt="banner"
              className="h-24 md:h-28 lg:h-32 w-auto object-contain drop-shadow"
            /> */}
          </div>
        </div>
      </div>

      {/* MAIN GRID */}
      <div className="mt-6 grid grid-cols-1 xl:grid-cols-3 gap-6">
        {/* LEFT COLUMN */}
        <div className="xl:col-span-2 space-y-6">
          {/* KPI CARDS */}
          <div className="no-scrollbar flex gap-4 overflow-x-auto pb-1">
            {loading ? (
              <>
                <Skeleton className="h-24 w-60" />
                <Skeleton className="h-24 w-60" />
                <Skeleton className="h-24 w-60" />
              </>
            ) : (
              <>
                <div className="min-w-[240px] flex-1 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                  <div className="w-[90%] flex items-center gap-3">
                    <img src={TeacherDas1} alt="" className="h-10 w-10" />
                    <div>
                      <p className="text-[11px] text-gray-500">{t("teacherDash.dashboard.onlineSessions")}</p>
                      <p className="text-2xl font-semibold text-gray-900">{onlineCount}</p>
                    </div>
                  </div>
                  <span className="mt-3 inline-block h-1 w-16 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
                </div>

                <div className="min-w-[240px] flex-1 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                  <div className="w-[90%] flex items-center gap-3">
                    <img src={TeacherDas2} alt="" className="h-10 w-10" />
                    <div>
                      <p className="text-[11px] text-gray-500">{t("teacherDash.dashboard.totalMentees")}</p>
                      <p className="text-2xl font-semibold text-gray-900">{totalStudents}</p>
                    </div>
                  </div>
                  <span className="mt-3 inline-block h-1 w-16 rounded-full bg-gradient-to-r from-[#2A3A54] to-[#EE5F2B]" />
                </div>

                {/* <div className="min-w-[240px] flex-1 rounded-2xl border border-gray-100 bg-white p-4 shadow-sm">
                  <div className="flex items-center gap-3">
                    <img src={TeacherDas3} alt="" className="h-10 w-10" />
                    <div>
                      <p className="text-[11px] text-gray-500">Home Tuitions</p>
                      <p className="text-2xl font-semibold text-gray-900">{homeCount}</p>
                    </div>
                  </div>
                  <span className="mt-3 inline-block h-1 w-16 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
                </div> */}
              </>
            )}
          </div>

          {/* RECENT STUDENTS */}
          <div className="rounded-3xl border border-gray-100 bg-white p-5 shadow-sm">
            <div className="mb-4 flex items-center justify-between">
              <h2 className="text-lg md:text-xl font-bold text-gray-900">{t("teacherDash.dashboard.mySessions")}</h2>
              <Link
                to="/mentor/my-mentee"
                className="text-sm font-semibold text-transparent bg-clip-text bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] hover:opacity-90"
              >
                {t("teacherDash.dashboard.viewAllArrow")}
              </Link>
            </div>

            {loading ? (
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                <Skeleton className="h-28" />
                <Skeleton className="h-28" />
                <Skeleton className="h-28" />
              </div>
            ) : lastThree.length === 0 ? (
              <div className="rounded-2xl border border-dashed border-gray-200 bg-gray-50 p-8 text-center">
                <p className="text-gray-800 font-semibold">{t("teacherDash.dashboard.noMenteesYet")}</p>
                <p className="text-gray-500 text-sm mt-1">
                  {t("teacherDash.dashboard.noMenteesSubtitle")}
                </p>
                <Link
                  to="/mentor/my-mentee"
                  className="mt-4 inline-block rounded-lg px-4 py-2 text-white text-sm font-semibold hover:opacity-95 transition-colors bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
                >
                  {t("teacherDash.dashboard.goToMyMentees")}
                </Link>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
                {lastThree.map((item, idx) => (
                  <div
                    key={`${item.student_id || idx}-${idx}`}
                    className="group relative rounded-2xl border border-gray-100 bg-white p-4 shadow-sm hover:shadow-md transition-shadow"
                  >
                    <div className="flex items-center gap-3">
                      <img
                        src={profile}
                        alt=""
                        className="h-10 w-10 rounded-full ring-1 ring-gray-200 object-cover"
                      />
                      <div className="min-w-0">
                        <p className="truncate text-sm font-semibold capitalize text-gray-900">
                          {item.student_name}
                        </p>
                        <p className="truncate text-xs text-gray-500">{item.subjects}</p>
                      </div>
                    </div>

                    <div className="mt-3 flex flex-wrap items-center gap-2">
                      <span className="inline-flex items-center rounded-full border border-gray-200 bg-gray-50 px-2.5 py-1 text-[11px] font-medium text-gray-700">
                        {t("teacherDash.dashboard.classLabel")} {item.class_name}
                      </span>
                      <span className="inline-flex items-center rounded-full border border-gray-200 bg-gray-50 px-2.5 py-1 text-[11px] font-medium text-gray-700 capitalize">
                        {t("teacherDash.dashboard.dayLabel")} {item.day_name || t("teacherDash.dashboard.undefined")}
                      </span>
                      <span className="ml-auto inline-flex items-center rounded-full px-2.5 py-1 text-[11px] font-semibold text-white bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54] capitalize">
                        {item.type_name}
                      </span>
                    </div>

                    <div className="pointer-events-none absolute inset-x-6 -bottom-8 h-12 translate-y-3 bg-gradient-to-r from-[#EE5F2B]/10 to-[#2A3A54]/10 blur-xl transition-all group-hover:translate-y-0" />
                  </div>
                ))}
              </div>
            )}
          </div>

          {error && (
            <div className="rounded-2xl border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          )}
        </div>

        {/* RIGHT SIDEBAR */}
        <aside className="space-y-6">
          {/* Quick Actions */}
          <div className="rounded-3xl border border-gray-100 bg-white p-5 shadow-sm">
            <h3 className="text-base font-bold text-gray-900">{t("teacherDash.dashboard.quickActions")}</h3>
            <div className="mt-4 space-y-3">
              <Link
                to="/mentor/my-mentee"
                className="block w-full rounded-xl px-4 py-2 text-center text-white text-sm font-semibold hover:opacity-95 transition-colors bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]"
              >
                {t("teacherDash.dashboard.manageMentees")}
              </Link>
              <Link
                to="/mentor/my-mentee"
                className="block w-full rounded-xl border border-gray-200 bg-white px-4 py-2 text-center text-sm font-semibold text-gray-700 hover:bg-gray-50"
              >
                {t("teacherDash.dashboard.scheduleSessions")}
              </Link>
            </div>
          </div>

          {/* Teaching Tips */}
          <div className="rounded-3xl border border-gray-100 bg-gradient-to-br from-white to-gray-50 p-5 shadow-sm">
            <div className="flex items-center gap-2">
              <span className="inline-block h-2 w-2 rounded-full bg-gradient-to-r from-[#EE5F2B] to-[#2A3A54]" />
              <h3 className="text-base font-bold text-gray-900">{t("teacherDash.dashboard.mentorshipTips")}</h3>
            </div>
            <ul className="mt-3 space-y-2 text-sm text-gray-600 list-disc list-inside">
              <li>{t("teacherDash.dashboard.tip1")}</li>
              <li>{t("teacherDash.dashboard.tip2")}</li>
              <li>{t("teacherDash.dashboard.tip3")}</li>
            </ul>
          </div>
        </aside>
      </div>
    </div>
  );
};

export default TeacherMainBody;
